// Server sanalarini o'qish — umumiy util'ga ko'chirildi (src/utils/serverDate.js).
// Video generator `date-time` maydonlarini vaqt mintaqasisiz qaytarishi mumkin — bunday qiymat UTC deb o'qiladi.
// Natija: millisekund (number) yoki null.
export { parseServerDate } from '../../../utils/serverDate';

// Daqiqalar (yuqoriga yaxlitlangan, kamida 1)
export function minutesUntil(targetMs, nowMs) {
  return Math.max(1, Math.ceil((targetMs - nowMs) / 60000));
}
